import styled from 'styled-components';

export const Container = styled.div`
  .list-table th {
    font-weight: 600;
    color: ${(props) => props.theme.$gray700};
    border-top: 0;
    white-space: nowrap;
  }

  .list-table td {
    vertical-align: middle;
  }

  .list-orgao {
    max-width: 280px;
  }

  .list-object {
    max-width: 380px;
  }

  .list-status {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    color: ${(props) => props.theme.$white};
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  @media print {
    .table-responsive {
      overflow: visible;
    }

    .list-orgao,
    .list-object {
      max-width: none;
    }

    .list-orgao .text-truncate {
      overflow: visible;
      white-space: normal;
    }

    .btn-long-text {
      display: none;
    }

    .list-status {
      padding: 0;
      background: none !important;
      color: ${(props) => props.theme.$gray900};
    }
  }
`;
